<template>
    <div>
        <app-reject
            v-if="id_two == 'reject' && reject"
            :id="id_two == 'reject'"
            :submit="submit_two == 'reject'"
            @onClose="() => { id_two = null, submit_two = null, show = true }"
            @onEvent="onReject">
        </app-reject>
        <app-model :class="{ 'show': show }" size="modal-xl">
            <template v-slot:header class="modal-header d-flex align-items-center">
                <h4 class="card-title mb-0">Evento # {{ event }}</h4>
                <button type="button" @click="onClose()" class="btn-close"></button>
            </template>
            <template v-slot:body class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Categoría</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.category ? record.category.name : '' }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Participantes</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.participants ? record.participants.length : 0 }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Día de la cita</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.date }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Hora de la cita</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.schedule ? record.schedule.start_time : '' }} - {{ record.schedule ? record.schedule.end_time : '' }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Estado</label>
                        <div class="py-0 col-md-8">
                          <label class="badge mb-1" :class="{ 'bg-success' : record.state == 1, 'bg-danger' : record.state == 2 , 'bg-primary' : record.state == 0 }">{{ record.state == 1 ? 'Aprobado' : record.state == 2 ? 'Rechazado' : 'En espera' }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Nombre</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.user ? record.user.first_name : '' }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Apellido</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.user ? record.user.last_name : '' }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Teléfono</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.user ? record.user.phone : '' }}</label>
                        </div>
                      </div>
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Correo electrónico</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.user ? record.user.email : '' }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="row">
                        <label class="py-0 col-md-4 col-form-label">Detalle</label>
                        <div class="py-0 col-md-8">
                          <label>{{ record.detail }}</label>
                        </div>
                      </div>
                    </div>
                </div>
                <hr class="my-4" v-if="record.state === 0">
                <div class="row mb-2" v-if="record.state === 0">
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                      <input type="text" class="form-control form-control-sm" placeholder="Nombre completo" v-model="append.name">
                    </div>
                  </div>
                  <div class="col-lg-4 py-1">
                    <div class="form-group">
                      <input type="text" class="form-control form-control-sm" placeholder="DPI / Pasaporte" v-model="append.cui">
                    </div>
                  </div>
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                      <input type="number" class="form-control form-control-sm" placeholder="Edad" v-model="append.age">
                    </div>
                  </div>
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                    <v-select
                        auto-select-first
                        :items="genders"
                        v-model="append.gender"
                        placeholder="Género"
                        class="form-control form-control-sm"
                        dense
                        hide-details
                        outlined>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                    <v-autocomplete
                        auto-select-first
                        item-text="nicename"
                        item-value="nicename"
                        :items="countries"
                        v-model="append.country"
                        placeholder="País de Origen"
                        class="form-control form-control-sm"
                        dense
                        hide-details
                        outlined>
                      </v-autocomplete>
                    </div>
                  </div>
                  <div class="col-lg-2 py-1">
                    <button class="btn btn-success btn-sm" @click="onAppend()">
                      <span v-if="submit_two == 'append'" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span :class="{ 'visually-hidden': submit_two == 'append' }">
                          <i class="ti ti-save me-1 fs-4"></i> Agregar participante
                      </span>
                    </button>
                  </div>
                </div>
                <hr class="my-4">
                <div v-if="record.participants.length > 0">
                  <div class="d-flex justify-content-between align-items-center mb-9">
                    <form class="position-relative">
                        <input type="text" v-model="search" class="form-control form-control-sm search-chat py-2 ps-5" id="text-srh" placeholder="Buscador usuario">
                        <i class="ti ti-search position-absolute top-50 start-0 translate-middle-y fs-6 text-dark ms-3"></i>
                    </form>
                  </div>
                  <div class="table-responsive border rounded">
                    <v-data-table
                      dense
                      :search="search"
                      :headers="headers.filter(e => {return record.state !== 0 ? e.value != 'delete' : e})"
                      :items="record.participants"
                      item-key="name">
                      <template v-slot:[`item.delete`]="{ index, item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <a href="javascript:void(0)" @click="onDelete(index, item.id)" class="link text-danger ms-2" v-bind="attrs" v-on="on">
                              <i class="ti ti-trash fs-4 remove-note"></i>
                            </a>
                          </template>
                          <small>Eliminar</small>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </div>
                </div>
                <div class="text-center" v-if="record.participants.length === 0">
                  <span class="font-weight-light text-muted">Sin participantes</span>
                </div>
            </template>
            <template v-slot:footer class="modal-footer">
                <button type="button" @click="onApprove()" v-if="record.state === 0 && approve" class="btn btn-success rounded-pill px-4">
                    <span v-if="submit_two == 'approve'" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span :class="{ 'visually-hidden': submit_two == 'approve' }">
                        <i class="ti ti-check me-1 fs-4"></i> Aprobar
                    </span>
                </button>
                <button type="button" @click="() => { id_two = 'reject', submit_two = null, show = false }" v-if="record.state === 0 && reject" class="btn btn-danger rounded-pill px-4">
                    <span v-if="submit_two == 'reject'" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span :class="{ 'visually-hidden': submit_two == 'reject' }">
                        <i class="ti ti-x me-1 fs-4"></i> Rechazar
                    </span>
                </button>
                <button type="button" @click="onClose()"
                    class="btn btn-dark rounded-pill px-4 ms-2 text-white">Cerrar</button>
            </template>
        </app-model>
    </div>
</template>
<script>
import AppReject from '@/pages/calendar/events/Reject'
export default {
  components: { AppReject },
  props: {
    id: {
      type: String | Number,
      default: null
    },
    submit: {
      type: Boolean,
      default: false
    },
    reject: {
      type: Boolean,
      default: false
    },
    approve: {
      type: Boolean,
      default: false
    },
    onEvent: {
      type: Function,
      default: () => { console.log('aca') }
    },
    data: {
      type: Object,
      default: () => {}
    },
    countries: {
      type: Array,
      default: () => []
    },
    event: {
      type: String | Number,
      default: null
    }
  },
  data () {
    return {
      show: false,
      menu1: false,
      menu2: false,
      record: {
        participants: []
      },
      search: '',
      headers: [
        { text: '#', value: 'id', sortable: false },
        { text: 'Nombre', value: 'name', sortable: false },
        { text: 'DPI', value: 'cui', sortable: false },
        { text: 'Eliminar', value: 'delete', sortable: false }
      ],
      genders: [
        { value: 'M', text: 'Masculino' },
        { value: 'F', text: 'Femenino' }
      ],
      id_two: null,
      submit_two: null,
      count: 0,
      append: {}
    }
  },
  created () {
    if (this.id) {
      this.$axios({
        url: '/appointments/' + this.event,
        method: 'GET'
      })
        .then((resp) => {
          this.record = resp.data
          this.show = true
        })
        .catch((_err) => {
          this.show = false
          this.$emit('onClose')
        })
    }
  },
  methods: {
    onClose: function () {
      this.show = false
      this.$emit('onClose')
    },
    onApprove: function () {
      this.submit_two = 'approve'
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/appointments/' + this.record.id,
        method: 'PUT',
        data: { state: 1 }
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.show = false
          this.$emit('onClose')
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.count = 0
          this.submit_two = ''
        })
    },
    onReject: function (reason) {
      this.submit_two = 'reject'
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/appointments/' + this.record.id,
        method: 'PUT',
        data: { state: 2, reason: reason }
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.show = false
          this.$emit('onClose')
        })
        .catch((err) => {
          console.log(err.response.data)
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.count = 0
          this.submit_two = ''
        })
    },
    onDelete: function (index, id) {
      this.count++
      if (this.count !== 1) {
        return
      }
      this.$axios({
        url: '/participants/' + id,
        method: 'DELETE'
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.record.participants.splice(index, 1)
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
        })
        .finally((resp) => {
          this.count = 0
        })
    },
    onAppend: function () {
      this.submit_two = 'append'
      this.count++
      if (this.count !== 1) {
        return
      }
      this.append.age = Number(this.append.age)
      this.$axios({
        url: '/append/participants/' + this.record.id,
        method: 'POST',
        data: this.append
      })
        .then((resp) => {
          this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.record.participants.push(resp.data.data)
          this.submit_two = ''
          this.append = {}
          this.count = 0
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message
          this.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          this.count = 0
          this.submit_two = ''
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/calendar/events/Event.vue